module.exports = __webpack_public_path__ + "static/img/01_05.1a09853f.jpg";